export const Grid = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M2.6665 5.33366H5.33317V2.66699H2.6665V5.33366ZM6.6665 13.3337H9.33317V10.667H6.6665V13.3337ZM2.6665 13.3337H5.33317V10.667H2.6665V13.3337ZM2.6665 9.33366H5.33317V6.66699H2.6665V9.33366ZM6.6665 9.33366H9.33317V6.66699H6.6665V9.33366ZM10.6665 2.66699V5.33366H13.3332V2.66699H10.6665ZM6.6665 5.33366H9.33317V2.66699H6.6665V5.33366ZM10.6665 9.33366H13.3332V6.66699H10.6665V9.33366ZM10.6665 13.3337H13.3332V10.667H10.6665V13.3337Z"
      fill="#3A5BC7"
    />
  </svg>
);
